import React, { useEffect, useState } from 'react';
import { Bell, ChevronRight } from 'lucide-react';
import api from '@/lib/api';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

/** Selo do Portal Equipe: estudantes aguardando a ciência do professor. */
export function CienciaBadge() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get('/dna-mapa/inclusao/pendencias').then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d || !d.total || d.manage) return null;
  const alunos = [...new Map(d.itens.map((r) => [r.student_id, r])).values()];
  const go = () => window.location.assign(window.location.pathname.startsWith('/equipe') ? '/equipe/dna-mapa' : '/v2/pedagogico/dna-mapa');
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" className="inline-flex items-center gap-2 rounded-full bg-amber-50 px-3 py-1.5 text-[12.5px] font-bold text-amber-800 ring-1 ring-amber-200 hover:bg-amber-100" data-testid="ciencia-badge">
          <Bell className="h-4 w-4" /> Ciência pendente ({alunos.length})
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-80 p-2" data-testid="ciencia-badge-lista">
        <p className="px-2 py-1 text-[11px] font-bold uppercase tracking-wider text-gray-500">Aguardando sua ciência</p>
        {alunos.map((r) => (
          <button key={r.student_id} type="button" onClick={go} className="flex w-full items-center gap-2 rounded-lg px-2 py-2 text-left text-[13px] hover:bg-purple-50" data-testid={`ciencia-badge-aluno-${r.student_id}`}>
            <span className="min-w-0 flex-1"><b className="block truncate">{r.student_name}</b><span className="text-[11px] text-gray-500">{d.itens.filter((x) => x.student_id === r.student_id).map((x) => x.label).join(' · ')}{r.nova_ciencia ? ' · nova versão' : ''}</span></span>
            <ChevronRight className="h-4 w-4 text-gray-400" />
          </button>
        ))}
        <button type="button" onClick={go} className="mt-1 w-full rounded-lg bg-[#2A1240] px-3 py-2 text-[12.5px] font-bold text-white" data-testid="ciencia-badge-abrir">Abrir DNA Mapa · Documentação e Inclusão</button>
      </PopoverContent>
    </Popover>
  );
}
